import PartnerHeader from "./header";
import { HeroButton } from "./button";
import { HeroBadge } from "@components/ui";

interface HeroData {
  title: string;
  description: string;
  image: string;
  buttonText: string;
  buttonInput?: boolean;
  buttonOnclick: () => void;
  footerText?: string;
  footerButtonText?: string;
  footerButtonOnclick?: () => void;
}

interface HeroProps {
  data: HeroData;
}
const Hero = ({ data }: HeroProps) => {
  const {
    buttonOnclick,
    buttonText,
    description,
    footerButtonOnclick,
    footerButtonText,
    footerText,
    image,
    title,
  } = data;

  return (
    <section className="relative w-full overflow-hidden bg-[#D48C07]">
      <div className="w-full max-w-[1728px] mx-auto flex flex-col items-start pt-6 md:pt-8 px-5 md:px-10 lg:px-16 xl:px-[121px] pb-10 md:pb-12 relative gap-6 md:gap-10 lg:gap-20 xl:gap-[145px]">
        {/* Header */}
        <header className="relative z-10 w-full">
          <PartnerHeader />
        </header>

        {/* Hero Content */}
        <div className="w-full max-w-full lg:max-w-[793px] flex flex-col items-start gap-8 md:gap-12 lg:gap-20 xl:gap-[120px] z-[3] text-white">
          <div className="flex flex-col items-start w-full gap-6 md:gap-10 lg:gap-16">
            <div className="flex flex-col items-start w-full gap-4 md:gap-6">
              <h1 className="text-[28px] sm:text-[35px] md:text-[48px] lg:text-[64px] xl:text-[76px] font-bold tracking-[-0.04em] leading-[1.1]">
                {title}
              </h1>
              <p className="text-[13px] sm:text-xs md:text-base lg:text-[20px] xl:text-[24px] tracking-[-0.04em] text-white/75 leading-[1.4]">
                {description}
              </p>
            </div>

            <div>
              <HeroButton onClick={buttonOnclick} title={buttonText} />
            </div>
          </div>

          {footerText && (
            <HeroBadge
              text={footerText}
              linkText={footerButtonText}
              onLinkClick={footerButtonOnclick}
            />
          )}
        </div>

        {/* Hero Image - Desktop */}
        <img
          src={image}
          alt="Hero illustration"
          className="hidden lg:block absolute top-[200px] xl:top-[228px] right-0 w-[450px] lg:w-[550px] xl:w-[677.7px] h-auto max-h-[1368px] z-[4]"
        />
      </div>
    </section>
  );
};

export default Hero;
